export const AUTO_VALUE = "auto";

export function toRem(value) {
  return value / 16;
}

export function toRemString(value) {
  if (value === AUTO_VALUE) {
    return value;
  }

  return `${toRem(value)}rem`;
}

/**
 * Parses a CSS-like padding string (e.g. "2.5rem 1rem 2.5rem 0")
 * into an object of CSS custom properties.
 *
 * Supports 1–4 values (CSS shorthand logic):
 * 1 → all sides
 * 2 → top/bottom | left/right
 * 3 → top | left/right | bottom
 * 4 → top | right | bottom | left
 *
 * @param {string} input
 * @returns {Record<string, string>}
 *
 * @example
 * parsePadding("2.5rem 1rem 2.5rem 0")
 * // returns { top: "2.5rem", right: "1rem", bottom: "2.5rem", left: "0" }
 * parsePadding("2.5rem 1rem 2.5rem")
 * // returns { top: "2.5rem", right: "1rem", bottom: "2.5rem", left: "1rem" }
 * parsePadding("2.5rem")
 * // returns { top: "2.5rem", right: "2.5rem", bottom: "2.5rem", left: "2.5rem" }
 * parsePadding("2.5rem 1rem")
 * // returns { top: "2.5rem", right: "1rem", bottom: "2.5rem", left: "1rem" }
 */
export function parsePadding(input = "") {
  const parts = input?.trim?.().split(/\s+/).filter(Boolean);

  if (!parts || parts.length === 0) {
    return {};
  }

  const all = parts[0];

  const top = all;
  const right = parts[1] ?? all;
  const bottom = parts[2] ?? all;
  const left = parts[3] ?? right;

  return {
    top,
    right,
    bottom,
    left,
  };
}
